import React, { type FC } from "react";
import { type WithTranslation, withTranslation } from "react-i18next";
import Avatar from "src/components/AICLayout/AICHeader/Avatar";
import LocationSelector from "src/components/AICLayout/AICHeader/LocationSelector/LocationSelector";
import PortalLogo from "src/components/AICLayout/AICHeader/PortalLogo";
import { getUsernameFromCookie, isMidwayCookieSet } from "src/cookies";

import NestNavBar from "./NestNavBar";
import "./AICHeader.css";
import { getUser } from "src/api/interfaces/user";

const AICHeader: FC<AICHeaderProps & WithTranslation> = ({
  disableCountryChange,
  fixedCountry,
  disableUrlSearchParamsUpdate,
  isNest,
}) => {
  const userName = getUsernameFromCookie();
  const user = getUser();

  const hideHeader = isNest && user === "VENDORCENTRAL";

  const headerClass = [
    "aic-header",
    isNest ? "aic-header--nest" : "",
    user === "VENDORCENTRAL" ? "aic-header--vendor-central" : "",
    hideHeader ? "aic-header--hidden" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={headerClass}>
      <div className="aic-header__content">
        <div>
          <PortalLogo isNest={isNest} />
        </div>
        <div className="aic-header__nav">
          <div className="aic-header__nav-items">
            <NestNavBar isNest={isNest} />
            <LocationSelector
              disableCountryChange={disableCountryChange}
              fixedCountry={fixedCountry}
              disableUrlSearchParamsUpdate={disableUrlSearchParamsUpdate}
            />
          </div>
          {isMidwayCookieSet() && (
            <>
              <div className="aic-header__user">
                <Avatar userAlias={userName} />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export interface AICHeaderProps {
  disableCountryChange?: boolean;
  fixedCountry?: string;
  disableUrlSearchParamsUpdate?: boolean;
  isNest?: boolean;
}

export default withTranslation()(AICHeader);
